import { render, staticRenderFns } from "./Adwords.vue?vue&type=template&id=03f4ecd6&"
import script from "./Adwords.vue?vue&type=script&lang=js&"
export * from "./Adwords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports